// HQ Live's server state (spec/14 §2, F-ANL-02): `GET /v1/hq/live` (`hq:organizations`, a second factor) — the read
// model the worker rebuilds every minute. Polled every 15 seconds while the page is open; the spec's `hq:live` channel
// can replace the poll without changing the page.

import { useQuery } from '@tanstack/react-query';

import { useApi } from '../../api/client';

/** How often HQ Live is re-read. The read model moves once a minute; this keeps the page within a quarter of it. */
const HQ_LIVE_REFRESH_MS = 15_000;

export const hqLiveKeys = { live: ['hq', 'live'] as const };

export function useHqLive() {
  const api = useApi();
  return useQuery({ queryKey: hqLiveKeys.live, queryFn: () => api.getHqLive(), refetchInterval: HQ_LIVE_REFRESH_MS });
}
